"use client";

/**
 * Pricing v2 client-side plan helpers (soft pre-checks only — the server is
 * authoritative). Reads the Convex `billingState` mirror (see backend
 * autumn.ts), which replaced the autumn-js useCustomer() shape. Check order
 * mirrors the backend: premium → free-tier allowances.
 */

/** Plans that grant premium (v2 passes + grandfathered legacy passes). */
export const PASS_PRODUCT_IDS = [
  "pass_weekly",
  "pass_lifetime",
  "exam_pass_week",
  "exam_pass_month",
];

export interface BillingBalance {
  remaining: number;
  granted: number;
  usage: number;
  unlimited: boolean;
  nextResetAt?: number;
}

/** Shape of api.autumn.getMyBillingState (null until first sync). */
export interface BillingState {
  premium: boolean;
  planIds: string[];
  renewsAt?: number;
  balances: Record<string, BillingBalance>;
  syncedAt: number;
}

export interface ClientPlan {
  premium: boolean;
  /** Free-tier daily practice-question pool. */
  questionBalance: number;
  questionIncluded: number | null;
  questionNextResetAt: number | null;
}

export function getClientPlan(billing: BillingState | null | undefined): ClientPlan {
  const premium = Boolean(billing?.premium);
  const pool = billing?.balances?.practice_questions;
  return {
    premium,
    questionBalance: typeof pool?.remaining === "number" ? pool.remaining : 0,
    questionIncluded: typeof pool?.granted === "number" ? pool.granted : null,
    questionNextResetAt: typeof pool?.nextResetAt === "number" ? pool.nextResetAt : null,
  };
}
